/**
 * Decoding helper function
 *
 * @param {number} charCode
 * @param {number} start
 * @param {number} end
 * @param {number} offset
 * @return {string}
 */
function decryptCharcode(charCode, start, end, offset) {
  charCode = charCode + offset;
  if (offset > 0 && charCode > end) {
    charCode = start + (charCode - end - 1);
  } else if (offset < 0 && charCode < start) {
    charCode = end - (start - charCode - 1);
  }
  return String.fromCharCode(charCode);
}

/**
 * Decodes string
 *
 * @param {string} value
 * @param {number} offset
 * @return {string}
 */
function decryptString(value, offset) {
  let result = '';
  for (let i = 0; i < value.length; i++) {
    const charCode = value.charCodeAt(i);
    if (charCode >= 0x2B && charCode <= 0x3A) {
      result += decryptCharcode(charCode, 0x2B, 0x3A, offset);	/* 0-9 . , - + / : */
    } else if (charCode >= 0x40 && charCode <= 0x5A) {
      result += decryptCharcode(charCode, 0x40, 0x5A, offset);	/* A-Z @ */
    } else if (charCode >= 0x61 && charCode <= 0x7A) {
      result += decryptCharcode(charCode, 0x61, 0x7A, offset);	/* a-z */
    } else {
      result += value.charAt(i);
    }
  }
  return result;
}

export function mailDecryption() {
  const mailtoElements = document.querySelectorAll('a[data-mailto-token][data-mailto-vector]');
  // `Array.from` for IE compatibility
  Array.from(mailtoElements).forEach(function (element) {
    element.addEventListener('click', function (evt) {
      evt.preventDefault();
      const target = evt.currentTarget as HTMLElement;
      if (!target || !target.dataset) {
        return;
      }
      const value = target.dataset.mailtoToken;
      const vector = target.dataset.mailtoVector;
      if (!vector) {
        return;
      }
      const offset = parseInt(vector, 10) * -1;
      document.location.href = decryptString(value, offset);
    });
  });
}

